import { Component, Input, input, ChangeDetectionStrategy } from '@angular/core';
import { HisWidgetGroup } from '../model/his-widget-group';
import { UntypedFormGroup } from '@angular/forms';

@Component( {
    selector: 'his-search-form-column',
    templateUrl: './his-search-form-column.component.html',
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
} )
export class HisSearchFormColumnComponent {

    /*Reactive signal inputs*/
    form = input.required<UntypedFormGroup>();
    widgetGroups = input.required<HisWidgetGroup[]>();
    showAllSearchCriteria = input.required<boolean>();

    /*Static/constant literal inputs*/
    @Input( { required: true } ) headingLevelWidgetTitle: number;
}